import comp from "./UIButton";
export default comp;
